import { __exportAll } from "../../../_virtual/_rolldown/runtime.js";
import { createElementBlock, createElementVNode, openBlock } from "vue";
//#region src/components/ScalarIcon/icons/NotAllowed.svg?component
var NotAllowed_exports = /* @__PURE__ */ __exportAll({
	default: () => NotAllowed_default,
	render: () => render$1
});
var _hoisted_1 = {
	xmlns: "http://www.w3.org/2000/svg",
	fill: "none",
	viewBox: "0 0 24 24"
};
function render$1(_ctx, _cache) {
	return openBlock(), createElementBlock("svg", _hoisted_1, [..._cache[0] || (_cache[0] = [createElementVNode("path", {
		stroke: "currentColor",
		"stroke-linecap": "round",
		"stroke-linejoin": "round",
		d: "m4.9 4.9 14.2 14.2M22 12c0 5.523-4.477 10-10 10S2 17.523 2 12 6.477 2 12 2s10 4.477 10 10"
	}, null, -1)])]);
}
var NotAllowed_default = { render: render$1 };
//#endregion
export { NotAllowed_exports, NotAllowed_default as default, render$1 as render };

//# sourceMappingURL=NotAllowed.svg.virtual.js.map